import React, { Component } from 'react';

import {Routes, Route, useNavigate} from "react-router-dom";
import CircularProgressWithLabel from './Components/Loader/Loader';
import IndexedDB from './Components/Database/IndexedDB';
import { LoadScript } from '@react-google-maps/api';

import i18n from './Components/i18n/i18n';

import SideMenu from './Components/SideMenu/SideMenu.js';
import Header from './Components/Header/Header.js';

//Import Pages
import Contacts from './Pages/Contacts/Contacts';
import AudioList from './Pages/AudioList/AudioList';
import AudioItem from './Pages/AudioItem/AudioItem';
import Map from './Pages/Map/Map';
import MapOffline from './Pages/Map/MapOffline';
import Help from './Pages/Help/Help';
import Page404 from './Pages/Page404/Page404';

import './App.scss';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            version: props.version,
            configs: props.configs,
            sideMenuStatus: false,
            open: false,
            locale: props.locale || 'en',
            access: false,
            audioData: [ ],
            url: props.url,
            apiKey: props.apiKey,
            visited: [ ],
            isLoading: true,
            loadProgress: null,
            debug: props.debug,
            offlineMode: props.offlineMode
        };

        this.dataRequest = null;

        this.changeMenuAction = this.changeMenuAction.bind(this);
        this.hideMenuAction = this.hideMenuAction.bind(this);
        this.changeLocale = this.changeLocale.bind(this);
        this.getDataFromUrl = this.getDataFromUrl.bind(this);
        this.getDataFromDB = this.getDataFromDB.bind(this);
        this.insertDataIntoDB = this.insertDataIntoDB.bind(this);
        this.updateVisited = this.updateVisited.bind(this);
        this.handleLanguageChanged = this.handleLanguageChanged.bind(this);
        this.loadVisited = this.loadVisited.bind(this);
        this.bootstrapData = this.bootstrapData.bind(this);

        console.log('configs',this.state.configs);
    }

    componentDidMount() {
        this.bootstrapData();
        i18n.changeLanguage(this.props.locale);
        i18n.on('languageChanged', this.handleLanguageChanged);
    }

    componentWillUnmount() {
        i18n.off('languageChanged', this.handleLanguageChanged);
        if (this.dataRequest) {
            this.dataRequest.abort();
            this.dataRequest = null;
        }
    }

    async bootstrapData() {
        try {
            if (this.state.apiKey) {
                await IndexedDB.deleteDatabase();
                await IndexedDB.init();
                await this.loadVisited();
                this.getDataFromUrl();
            } else {
                await IndexedDB.init();
                await this.loadVisited();
                this.getDataFromDB();
            }
        } catch (error) {
            console.error(error);
            this.setState({ isLoading: false });
        }
    }

    async loadVisited() {
        try {
            const visited = await IndexedDB.getVisited();
            this.setState({ visited: visited || {} });
        } catch (error) {
            console.error(error);
            this.setState({ visited: {} });
        }
    }

    handleLanguageChanged() {
        this.setState({ locale: i18n.language });
    }

    async getDataFromDB() {
        try {
            const audioData = await IndexedDB.get();
            this.setState({
                audioData: audioData || [],
                isLoading: false
            });
        } catch (error) {
            console.error(error);
            this.setState({
                audioData: [],
                isLoading: false
            });
        }
    }

    insertDataIntoDB(data) {
        return IndexedDB.update(data);
    }

    getDataFromUrl() {
        if (this.dataRequest) {
            this.dataRequest.abort();
        }

        const request = new XMLHttpRequest();
        this.dataRequest = request;

        request.open('GET', this.state.url);
        request.responseType = 'json';

        request.onprogress = (event) => {
            if (event.lengthComputable && event.total > 0) {
                this.setState({
                    loadProgress: Math.round((event.loaded / event.total) * 100)
                });
            }
        };

        request.onload = async () => {
            this.dataRequest = null;

            if (request.status < 200 || request.status >= 300) {
                return;
            }

            const response = request.response;

            if (!response || !response.audios) {
                this.setState({
                    audioData: response || [],
                    isLoading: false,
                    loadProgress: 100
                });
                return;
            }

            try {
                await this.insertDataIntoDB(response);
                const cachedData = await IndexedDB.get();

                if (this.props.navigate) {
                    this.props.navigate({ pathname: '/', search: '' }, { replace: true });
                }

                this.setState({
                    audioData: cachedData || response,
                    apiKey: null,
                    isLoading: false,
                    loadProgress: 100
                });
            } catch (error) {
                console.error(error);
                this.setState({
                    audioData: response,
                    isLoading: false,
                    loadProgress: 100
                });
            }
        };

        request.onerror = () => {
            this.dataRequest = null;
        };

        request.onabort = () => {
            this.dataRequest = null;
        };

        request.send();
    }

    changeMenuAction = (e) => {
        this.setState({
            open: !this.state.open
        });
    }

    hideMenuAction = (e) => {
        this.setState({
            open: false
        });
    }

    changeLocale(lng) {
        i18n.changeLanguage(lng).then(() => {
            this.setState({ locale: lng });
        });
    }

    updateVisited = (e) => {
        let visited = this.state.visited;
        visited[e] = true;
        this.setState({
            visited: visited
        });
        IndexedDB.updateVisited(e);
    }

    changeLoadingData = (e) => {

//        this.setState({
//            loadingData: e
//        });

    }

    render() {

        if (this.state.isLoading) {
            return <div translation="no" className="loader">
                <div className="loader-panel">
                    <img
                        className="loader-logo"
                        alt="Smart Guide"
                        src="/images/logo.png"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            if (e.target.nextSibling) {
                                e.target.nextSibling.classList.remove('loader-brand--hidden');
                            }
                        }}
                    />
                    <h1 className="loader-brand loader-brand--hidden">Smart Guide</h1>
                    <CircularProgressWithLabel
                        size={this.state.loadProgress != null ? 84 : 48}
                        thickness={4}
                        value={this.state.loadProgress != null ? this.state.loadProgress : undefined}
                    />
                    <p className="loader-message">
                        Loading the tour points — please wait a moment.
                    </p>
                </div>
            </div>;
        }
        
        if (this.state.audioData.audios) {
            return <div translation="no" className="body">
                <Header menuAction={this.changeMenuAction} changeLocale={this.changeLocale} activeMenu={this.state.open} disabledLanguage={false} disabledMenu={false} locale={this.state.locale} />
                <SideMenu menuAction={this.changeMenuAction} status={this.state.open} version={this.props.version} debug={this.state.debug} offlineMode={this.state.offlineMode}/>
                <main className="content">
                    {this.state.offlineMode ? <div className='offline-mode-label'>Offline Mode</div> : "" }
                    <div className='body-content'>
                        <LoadScript googleMapsApiKey={this.props.configs.google_configs.map.google_map_api_key}>
                            <Routes>
                                {this.state.offlineMode === false ?
                                    <Route path='/' element={ < Map offlineMode = {this.state.offlineMode} debug = {this.state.debug} configs = {this.props.configs.google_configs.map} audioData = {this.state.audioData} visited = {this.state.visited} version = {this.props.version} / > }/>
                                                                :
                                                            <Route path='/map' element={ < MapOffline offlineMode = {this.state.offlineMode} debug = {this.state.debug} configs = {this.props.configs.google_configs.map} audioData = {this.state.audioData} visited = {this.state.visited} version = {this.props.version} / > }/>
                                                            }
                                                            <Route path={this.state.offlineMode ? "/" : "/audios"} element={ < AudioList audioData = {this.state.audioData} offlineMode = {this.state.offlineMode} / > }/>
                                                            <Route path="/audios/audio-item/:id" element={ < AudioItem audios = {this.state.audioData.audios} updateVisited = {(e) => this.updateVisited(e)} debug = {this.state.debug} / > } />
                                                            <Route path="contacts" element={ < Contacts / > }/>
                                                            <Route path="help" element={ < Help / > }/>
                                                            <Route path="*" element={ < Page404 / > }/>
                                                            <Route path="/page-not-found" element={ < Page404 / > }/>
                                                        </Routes>
                                                    </LoadScript>
                                                </div>
                                            </main>
                                        </div>;
                                                                    }

                                                                    return (<div className="body">
                                                                        <Header menuAction={this.changeMenuAction} changeLocale={this.changeLocale} activeMenu={this.state.open} disabledLanguage={false} disabledMenu={true} locale={this.state.locale} />
                                                                        <div className="no-data-message">
                                                                            <div>{i18n.t('noDataMessageNoOrderLabel')}</div><br/>
                                                                            <div>{i18n.t('noDataMessagePurcheLabel')}</div>
                                                                            <a target="_blank" className="no-date-message-link" href="https://www.smartguide.bg">Smartguide</a>
                                                                            <div>{i18n.t('noDataMessageLoadFromYourEmailLabel')}</div>
                                                                        </div>
                                                                    </div>);
                                                                }
                                                                ;
                                                            }

function AppWithNavigate(props) {
    const navigate = useNavigate();
    return <App {...props} navigate={navigate} />;
}

export default AppWithNavigate;
